import React from 'react';
import PropTypes from 'prop-types';

import QuickStartProgressSection from './QuickStartProgressSection';

import styles from './QuickStartProgressBar.module.scss';

export default function QuickStartProgressBar({
  completed,
  isLoading,
  sections,
  testIdPrefix,
}) {
  return (
    <div
      className={styles.wrapper}
      data-testid={`${testIdPrefix}__progressBar`}
    >
      <div className={styles.inner}>
        {sections.map(section => (
          <QuickStartProgressSection
            key={section.sectionId}
            isLoading={isLoading}
            section={section}
            isComplete={completed.includes(section.sectionId)}
            testIdPrefix={testIdPrefix}
          />
        ))}
      </div>
    </div>
  );
}

QuickStartProgressBar.propTypes = {
  completed: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  sections: PropTypes.array.isRequired,
  testIdPrefix: PropTypes.string.isRequired,
};

QuickStartProgressBar.displayName = 'QuickStartProgressBar';
